


import {Component,  Vue} from 'vue-property-decorator';
import {namespace} from "vuex-class";

import { loader } from "@/helpers/loader";

const app = namespace('app')
const newauth = namespace('newauth')
const device = namespace('device')
const profile = namespace('profile')
const event = namespace('event')
const dialog = namespace('dialog')
const resources = namespace('resources')

@Component({
  name: 'Init'
})
export default class Init extends Vue {
  @device.Action('initUid') protected initUid: any
  @newauth.Getter('isAuthenticated') protected isAuthenticated: any
  @profile.Action('getCompanyFromServer') protected getCompanyFromServer: any
  @profile.Action('getUserInvitesFromServer') protected getUserInvitesFromServer: any
  @profile.Action('getUserFromServer') protected getUserFromServer: any
  @profile.Mutation('setCurrentWorkspace') protected setCurrentWorkspace: any
  @profile.Getter('getUser') protected getUser: any

  @app.Getter('appLoaded') protected appLoaded: any
  @app.Mutation('setAppLoaded') protected setAppLoaded: any
  
  @dialog.Mutation('SetFullErrorShow') protected SetFullErrorShow : any
  @dialog.Mutation('SetTitleError') protected SetTitleError : any
  @dialog.Mutation('SetSubtitleError') protected SetSubtitleError : any
  @dialog.Mutation('SetIsBtnSupport') protected SetIsBtnSupport : any
  @dialog.Mutation('SetIsCopyError') protected SetIsCopyError : any
  @dialog.Mutation('SetIsBtnLogout') protected SetIsBtnLogout : any
  @dialog.Getter('fullErrorShow') protected fullErrorShow: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any

  async created() {
    loader.add()
    this.setAppLoaded(false)
    if (!localStorage['region'] || localStorage['region'] === undefined || !['RU','EU'].includes(localStorage['region'])){
      await this.$router.push({name:'Logout'}).catch(() => {})
    } else {
      if (this.isAuthenticated) {
        // await this.initUid() //device id
        await this.getUserFromServer() //user
        if( this.getUser != null && this.getUser.isBlocked) {
          this.SetFullErrorShow(true)
          this.SetTitleError(this.$t('error.block.title'))
          this.SetSubtitleError(this.$t('error.block.text'))
          this.SetIsBtnSupport(false)
          this.SetIsCopyError(false)
          this.SetIsBtnLogout(true)
        } else {
          await this.getCountryFromServer() // countryes

          await this.getCompanyFromServer()  //companies
          await this.getUserInvitesFromServer() // invites
        }
      }
    }


    this.setAppLoaded(true)
    loader.remove()
  }
}
